import { Flex } from '@chakra-ui/react'
import { RestrictedGovtMasthead } from '@opengovsg/design-system-react'

import { FeatureFlagBanner } from '~components/FeatureFlagBanner'
import { HackathonBanner } from '~components/HackathonBanner'

interface BaseElementProps {
  /**
   * If `strict` is true, only non-authed users can access the route.
   * i.e. signin page, where authed users accessing that page should be
   * redirected out.
   * If `strict` is false, then both authed and non-authed users can access
   * the route.
   * Defaults to `false`.
   */
  strict?: boolean
  element: React.ReactElement
}

export const BaseElement = ({
  element,
}: BaseElementProps): React.ReactElement => {
  return (
    <Flex flexDir="column" minH="$100vh" maxH="$100vh" height="100vh">
      <HackathonBanner />
      <FeatureFlagBanner variant={'primary-banner'} />
      <RestrictedGovtMasthead />
      {element}
    </Flex>
  )
}
